export const GENRE_MODEL = 'genre';

export interface GenreArtistPreview {
  id: number;
  name: string;
  image_small?: string | null;
}

export interface Genre {
  id: number;
  name: string;
  display_name: string | null;
  model_type: 'genre';
  image?: string | null;
  artists?: GenreArtistPreview[];
}
